import React, { Component } from "react";
import { FormGroup, FormControl, FormLabel, Button } from "react-bootstrap";

import i18n from "i18next";
import PropTypes from "prop-types";

export default class OneClickEditProvider extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.index = 0;
    /**
     * Component's initial state
     */
    this.state = {
      open: false,
    };
  }

  /**
   * Render React Component
   * @returns {XML}
   */
  render() {
    let bckg = this.props.formControlProps
      ? this.props.value !== undefined
        ? this.props.value
        : this.props.formControlProps.value
      : null;
    let isURI = /data\:/.test(bckg);
    let props = {
      ...this.props.formControlProps,
      placeholder: isURI ? "http://..." : "",
      value: isURI ? "" : bckg,
    };

    let mark = Object.keys(this.props.marks)
      .map((key) => this.props.marks[key])
      .find((r) => r.origin == this.props.id);

    return (
      <FormGroup style={{ display: this.props.hide ? "none" : "block" }}>
        <Button
          className={"toolbarButton"}
          onClick={() => {
            this.setState({ open: !this.state.open });
            if (mark != null) {
              this.props.onRichMarkEditPressed(mark);
            }
            this.props.onOneClickEditModalToggled();
          }}
        >
          {props.label}
        </Button>
      </FormGroup>
    );
  }
}

OneClickEditProvider.propTypes = {
  /**
   * Toolbar input inherited props
   */
  formControlProps: PropTypes.object,
  /**
   * Input Value
   */
  value: PropTypes.any,
  /**
   * Open File Modal
   */
  openModal: PropTypes.func,
  /**
   * Id of the box/page being edited
   */
  id: PropTypes.any,
  /**
   * Mime Type accepted
   */
  accept: PropTypes.string,
  /**
   * Button text
   */
  buttontext: PropTypes.string,
  /**
   * Last files uploaded to server or searched in modal
   */
  fileModalResult: PropTypes.object,
  /**
   * Toolbar change callback
   */
  onChange: PropTypes.func,
  /**
   * Hide external provider input type
   */
  hide: PropTypes.bool,
};
